import {
    GET_TRANSACTION_NETWORK_DEF_SUCCESS,
    TRANSACTION_NETWORK_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
}

const transactionNetworkDef = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_TRANSACTION_NETWORK_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }

        case TRANSACTION_NETWORK_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default transactionNetworkDef